<template>
    <div class="px-3">
        <div style="position:sticky;top:0;z-index:20;background:#ffffff;padding:0;">
            <div class="kpi-btn-bar">
                <v-btn class="fbtn fbtn-cancel mr-2" @click="backHandler">
                    <v-icon size="16" class="mr-1">mdi-arrow-left</v-icon>
                    {{$t('button.back')}}
                </v-btn>
                <v-btn
                    v-if="parentObject.pmkpiexercisestatus != 'REVIEWED'"
                    class="fbtn fbtn-secondary"
                    @click="addProgress">
                    <v-icon size="16" class="mr-1">mdi-plus</v-icon>
                    {{$t('button.addnew')}}
                </v-btn>
            </div>
            <h2 class="kpi-page-title">
                <v-icon size="20" color="#1261a0" class="mr-2" style="vertical-align:middle;">mdi-chart-line</v-icon>
                {{$t('pmselfservice.kpiprogressandcomments')}}
            </h2>
        </div>

        <v-container fluid class="pa-0 pr-3 pb-6">
            <v-row>
                <v-col cols="12" md="6">
                    <v-card style="background-color: #F1F5F9; color:#1E293B;">
                        <v-card-title class="pb-1 pt-2" style="font-size:0.72rem;font-weight:700;color:#1a3a5c;letter-spacing:normal;line-height:1.3;">{{ parentObject.kpi.goal }}</v-card-title>
                        <v-card-text>
                            <v-expansion-panels v-model="expandedPanelKPI">
                                <v-expansion-panel>
                                    <v-expansion-panel-header style="background-color: #E9EDF2; color:#1a3a5c;">
                                        <div style="flex: 1; text-align: left; white-space: nowrap;">
                                            {{$t('pmreviewexercisesectioncard.weightage')}}: <strong>{{ parentObject.kpi.weightage }}%</strong>
                                        </div>

                                        <div style="flex: 1; text-align: right; white-space: nowrap;">
                                            {{$t('pmreviewexercisesectioncard.progress')}}: <strong>{{ parentObject.kpi.progress || 0 }}<span v-if="parentObject.kpi.basedonpercentage">%</span></strong>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div class="mb-2">
                                            {{$t('pmreviewexercisesectioncard.KPI')}}
                                            <br>
                                            <strong>{{ parentObject.kpi.kpi }}</strong>
                                        </div>
                                        <div class="mb-2">
                                            {{$t('columns.target')}}
                                            <br>
                                            <strong>{{ parentObject.kpi.target }}</strong>
                                        </div>
                                        <div v-if="parentObject.kpi.threshold" class="mb-2">
                                            {{$t('pmreviewexercisesectioncard.threshold')}} 
                                            <br>
                                            <strong>{{ parentObject.kpi.threshold }}</strong>
                                        </div>
                                        <div v-if="parentObject.kpi.stretch" class="mb-2">
                                            {{$t('pmreviewexercisesectioncard.stretch')}}
                                            <br>
                                            <strong>{{ parentObject.kpi.stretch }}</strong>
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card style="background-color: #F1F5F9; color:#1E293B;">
                        <v-card-title class="pb-1 pt-2" style="font-size:0.72rem;font-weight:700;color:#1a3a5c;letter-spacing:normal;">
                            <span>{{$t('pmselfservice.progressandcomments')}}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-expansion-panels multiple v-model="expandedPanelProgressReviews">
                                <v-expansion-panel v-for="review in progressReviewList" :key="review.id">
                                    <v-expansion-panel-header style="background-color: #E9EDF2; color:#1a3a5c;">
                                        <div style="flex: 2; text-align: left; white-space: nowrap;">
                                            <strong>
                                                <span v-if="review.isGenerated == 1" style="margin-right: 4px;">*</span>
                                                {{ review.reviewdate }}
                                            </strong>
                                        </div>

                                        <div style="flex: 1; text-align: right; white-space: nowrap;">
                                            <span v-if="parentObject.kpi.basedonpercentage">{{$t('pmreviewexercisesectioncard.progress')}}</span>
                                            <span v-else>{{$t('pmreviewexercisesectioncard.achievement')}}</span>:
                                            <strong>
                                                {{ review.progress }}<span v-if="parentObject.kpi.basedonpercentage">%</span>
                                            </strong>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <div class="mb-2">
                                            {{$t('pmreviewexercisesectioncard.achievement')}}
                                            <br>
                                            <strong>{{ review.achievement }}</strong>
                                        </div>
                                        <div class="mb-2">
                                            {{$t('appraisalrecord.reviewer')}}
                                            <br>
                                            <strong>{{ review.reviewername }} - {{ review.reviewercode}}</strong>
                                        </div>
                                        <div class="mb-2">
                                            {{$t('columns.comment')}}<br>

                                            <template v-if="review.comments.length > 0">
                                                <div v-for="(c, i) in review.comments" :key="i" class="mb-1">
                                                <strong>{{ c.staffname }} - {{ c.staffcode }} : </strong>
                                                <span>{{ c.comment }}</span>
                                                </div>
                                            </template>

                                            <template v-else>
                                                <span>-</span>
                                            </template>
                                        </div>
                                        <div class="mb-2">
                                            {{$t('recstaffdetails.attachment')}}
                                            <br>
                                            <p style="font-size: 0.75rem;"> 
                                                <a v-bind:href="review.attach"  v-bind:download="review.attachname">
                                                    {{review.attachname}}
                                                </a>
                                            </p>
                                        </div>
                                        <!-- <v-row v-if="formData.attach" class="pb-n4 mt-n8 pl-0 ml-0">
                                            <v-col cols="3" class="ml-0 pl-0">
                                                <p style="font-size: 0.75rem;"> <b>{{ $t('recstaffdetails.attachment') }}</b> - 
                                                    <a v-bind:href="this.formData.attach"  v-bind:download="this.formData.attachname">
                                                        {{formData.attachname}}
                                                    </a>
                                                </p>
                                            </v-col>
                                        </v-row> -->
                                        <div v-if="review.reviewerid == formData.reviewerid || review.isGenerated" style="text-align: right;"> 
                                            <v-btn v-if="parentObject.pmkpiexercisestatus != 'REVIEWED'" color="primary" class="mr-2" @click="editProgress(review)">
                                                  {{$t('button.edit')}}
                                            </v-btn>
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="progressDialog" max-width="900px">
          <v-card>
            <v-card-title class="dialog-header">
                {{$t('pmselfservice.addprogressandcomments')}}
            </v-card-title>
            <v-card-text>
              <v-container class="pa-0 pt-3">
                    <v-row class="mt-0">
                        <v-col cols="3" class="py-0">
                            <v-text-field
                                outlined
                                :label="$t('pmreviewexercisesectioncard.reviewdate')"
                                type="date"
                                :rules="[rules.required]"
                                v-model="formData.reviewdate"
                                dense
                                :readonly="formData.isGenerated == 1"
                                :background-color="formData.isGenerated == 1 ? '#ffeab2' : undefined"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="4" class="py-0">
                            <v-text-field
                                outlined
                                :label="$t('pmreviewexercisesectioncard.achievement')"
                                type="number"
                                :rules="[rules.required]"
                                v-model="formData.achievement"
                                ref="target"
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col v-if="isEdit && parentObject.kpi.basedonpercentage" cols="4" class="py-0">
                            <v-text-field
                                outlined
                                :label="$t('pmreviewexercisesectioncard.progress')"
                                type="number"
                                v-model="formData.progress"
                                ref="stretch"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="12" class="py-0">
                            <v-textarea
                                outlined
                                :label="$t('columns.comment')"
                                type="text"
                                v-model="formData.comment"
                                dense
                                auto-grow
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="11" class="py-0">
                            <v-file-input
                                ref="attach"
                                :label="formData.attach ? 'Reference: ' + formData.attachname : 'No file selected'"
                                outlined
                                v-model="fileHolder"
                                @change="fileToBase64('formData')"
                                dense
                            ></v-file-input>
                        </v-col>
                        <v-col cols="1" class="py-0 d-flex align-center">
                            <v-icon @click="deleteItemHandler">mdi-delete</v-icon>
                        </v-col>
                    </v-row>
              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="saveHandler">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="closeHandler">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div v-if="isErr">
        <app-error
            v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
        />
        </div>
    </div>
</template>

<script>

import moment from 'moment';
import ErrorDialog from "../../components/common/ErrorDialog";

export default {

    props: {
        parentObject: Object,
    },

    components: {
        "app-error": ErrorDialog,
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            progressDialog: false,

            formData: {
                id: this.parentObject.kpi.id,
                progreselfservicereviewid: null,
                progreselfservicereviewcommentid: null,
                reviewdate: null,
                achievement: null,
                progress: null,
                isGenerated: 0, // Default to 0, will be set to 1 if the review is generated
                reviewerid: this.$store.getters.staffId, 
                attach: null,
                attachname: null,
                comment: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            progressReviewList: [],
            progressCommentsList: [],
            staffList: [],
            fileHolder: null,

            isErr: false,
            errMsg: '',
            isEdit: false,
            expandedPanelKPI: 0,
            expandedPanelProgressReviews: [],
        };
    },

    watch: {
        progressReviewList(newList) {
            this.expandedPanelProgressReviews = newList.map((_, i) => i);
        }
    },

    methods: {
        deleteItemHandler() {
          this.formData.attach = ''
          this.formData.attachname = ''
        },

        fileToBase64() {
          if (this.fileHolder) {
            var file = this.$refs.attach.internalValue;
                this.formData.attachname = this.fileHolder.name
            
            var reader = new FileReader();

            reader.onloadend = () => {
                //var b64 = reader.result.replace(/^data:.+base64,/, '');
                var b64 = reader.result;
                  this.formData.attach = b64
            }

            reader.readAsDataURL(file);
          } else {
                this.formData.attach = null
          }
        },

        backHandler(){
            const vm = this;
            this.$router.push({ name: 'selfservicemystaffkpidetails', params: { kpi: vm.parentObject.basekpi, list: vm.parentObject.list, roleName: vm.parentObject.roleName, staffData: vm.parentObject.staffData } });
        },

        addProgress() {
            this.isEdit = false;
            this.resetSelections();
            this.progressDialog = true;
        },

        editProgress(review){
            this.isEdit = true;
            this.formData = { ...this.formData, ...review};
            this.formData.comment = review.comments.map(comment => comment.comment).join('\n');
            this.formData.progreselfservicereviewid = review.id;
            this.formData.progreselfservicereviewcommentid = review.comments.map(comment => comment.id).join(',');
            this.formData.isGenerated = review.isGenerated;
            this.formData.attach = review.attach;
            this.formData.attachname = review.attachname;
            const reviewDate = moment(review.reviewdate, 'DD-MM-YYYY'); 
            if (reviewDate.isValid()) {
                this.formData.reviewdate = reviewDate.format('YYYY-MM-DD'); 
            } else {
                console.error("Invalid date:", review.reviewdate);
                this.formData.reviewdate = ""; // Handle invalid date case
            }
            console.log("Edit Progress:", this.formData);
            this.progressDialog = true;
        },

        saveHandler() {
            //ADD is most commonly for progress review isGenerated != 1, so does not affect much
            //EDIT is most commonly for progress review isGenerated = 1, so it will affect the Individual KPI progress

            const vm = this;

            //Calculate progress
            if (vm.parentObject.kpi.basedonpercentage){
                vm.formData.progress = Number(((vm.formData.achievement / vm.parentObject.kpi.target) * 100).toFixed(2));
            }else{
                vm.formData.progress = vm.formData.achievement;
            }

            vm.formData.reviewerid = this.$store.getters.staffId;
            if(!vm.isEdit){
                this.$store.dispatch('post', {url: "/kpiindividual/progressreview/create/", payload: vm.formData})
                .then(async (res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        // vm.errMsg = res.data.error;
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        const newReview = res.data.result; // Response data from the server

                        // Find the matching staff for the reviewer
                        const matchingStaff = vm.staffList.find(staff => staff.value === newReview.reviewerid);

                        // Format the new review object
                        const formattedReview = {
                            ...newReview,
                            reviewdate: moment(newReview.reviewdate).format('DD-MM-YYYY'), // Format the review date
                            reviewername: matchingStaff ? matchingStaff.psnname : null,
                            reviewcompany: matchingStaff ? matchingStaff.staffcompany : null,
                            reviewercode: matchingStaff ? matchingStaff.staffcode : null,
                            comments: [], // Initialize comments as an empty array
                        };

                        // Fetch comments for the new review (if needed)
                        const comments = await vm.loadProgressCommentsList(formattedReview.kpiexerciseindkpiprgid);
                        formattedReview.comments = comments;

                        // Add the formatted review to the progressReviewList
                        vm.progressReviewList.push(formattedReview);

                        console.log("Newly added review:", formattedReview);
                        this.closeHandler();
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err.message || err;
                });
            }else{
                this.$store.dispatch('put', {url: "/kpiindividual/progressreview/" + vm.formData.progreselfservicereviewid, payload: vm.formData})
                .then(async (res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        // vm.errMsg = res.data.error;
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        // Update progress review comment
                        await vm.updateProgressReviewComment(vm.formData.progreselfservicereviewid, vm.formData.comment);

                        // Update the progressReviewList
                        const updatedReview = { ...vm.formData };

                        // Find the matching staff for the reviewer
                        const matchingStaff = vm.staffList.find(staff => staff.value === updatedReview.reviewerid);

                        // Format the updated review object
                        const formattedReview = {
                            ...updatedReview,
                            reviewdate: moment(updatedReview.reviewdate).format('DD-MM-YYYY'),
                            reviewername: matchingStaff ? matchingStaff.psnname : null,
                            reviewcompany: matchingStaff ? matchingStaff.staffcompany : null,
                            reviewercode: matchingStaff ? matchingStaff.staffcode : null,
                        };

                        // Fetch the updated comments for this review
                        const comments = await vm.loadProgressCommentsList(updatedReview.progreselfservicereviewid);
                        formattedReview.comments = comments;

                        // Update the specific review in the progressReviewList
                        const index = vm.progressReviewList.findIndex(item => item.id === formattedReview.id);
                        if (index !== -1) {
                            vm.$set(vm.progressReviewList, index, formattedReview); // Ensure reactivity
                        }

                        if (formattedReview.isGenerated == 1) {
                           if (vm.parentObject.kpi.pmkpifinalscorecalmethodid == 1) { // Take Average
                            // Calculate the average progress from all reviews that isGenerated = 1
                            const generatedReviews = vm.progressReviewList.filter(item => item.isGenerated === 1);
                            if (generatedReviews.length > 0) {
                                const totalProgress = generatedReviews.reduce((sum, item) => sum + item.progress, 0);
                                vm.parentObject.kpi.progress = totalProgress / generatedReviews.length;
                            } 
                            } else if (vm.parentObject.kpi.pmkpifinalscorecalmethodid == 2) { // Take Last
                                //if calculation = take last 
                                //check between review dates and update progress
                                const latestReview = this.progressReviewList
                                    .filter(item => item.isGenerated === 1)
                                    .reduce((latest, item) => {
                                        return (!latest || (item.reviewdate && item.reviewdate > latest.reviewdate)) ? item : latest;
                                    }, null);
                                if (latestReview) {
                                    vm.parentObject.kpi.progress = latestReview.progress;
                                }
                            } 
                        } 
                        
                        console.log("Updated review:", formattedReview);
                        this.closeHandler();
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err.message || err;
                });
            }
        },

        async updateProgressReviewComment(progressReviewId, comment) {
            try {
                await this.$store.dispatch('put', { 
                    url: `/sskpiindividual/progressreview/comment/${progressReviewId}`, 
                    payload: { comments: comment, commentby: this.$store.getters.staffId , stamp: 0, updatedby: this.$store.getters.userId }  
                });
                console.log(`Updated comment for progress review ID: ${progressReviewId}`);
            } catch (err) {
                console.error("Error updating progress review comment:", err);
            }
        },

        loadProgressReviewList() {
            const vm = this;
            this.$store.dispatch('get', { url: "/kpiindividual/progressreview/" + this.parentObject.kpi.id })
                .then(async function (res) {
                    vm.progressReviewList = res.data.rec;
                    // Format review dates and fetch staff details
                    vm.progressReviewList.forEach(review => {
                        review.reviewdate = moment(review.reviewdate).format('DD-MM-YYYY');

                        // Find the matching staff from staffList
                        const matchingStaff = vm.staffList.find(staff => staff.value === review.reviewerid);

                        if (matchingStaff) {
                            // Add staff information to the review
                            review.reviewername = matchingStaff.psnname;
                            review.reviewcompany = matchingStaff.staffcompany;
                            review.reviewercode = matchingStaff.staffcode;
                        }
                    });

                    // Fetch comments for each progress review
                    await Promise.all(
                        vm.progressReviewList.map(async review => {
                            const comments = await vm.loadProgressCommentsList(review.id);
                            console.log("comments: ", comments);
                            vm.$set(review, 'comments', comments); // Use Vue's reactivity system
                        })
                    );

                    console.log("progressReviewList with comments: ", vm.progressReviewList);
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });
        },


        async loadProgressCommentsList(id) {
            try {
                const res = await this.$store.dispatch('get', { url: "/kpiindividual/progressreview/comment/" + id });
                return res.data.rec.map(comment => {
                    // Find the matching staff from staffList
                    const matchingStaff = this.staffList.find(staff => staff.value === comment.commentby);

                    return {
                        id: comment.id,
                        comment: comment.comments,
                        commentBy: comment.commentby,
                        progressId: comment.kpiexerindkpiprgid,
                        staffname: matchingStaff ? matchingStaff.psnname : null,
                        staffcompany: matchingStaff ? matchingStaff.staffcompany : null,
                        staffcode: matchingStaff ? matchingStaff.staffcode : null,
                    };
                });
            } catch (err) {
                console.error("Error in loadProgressCommentsList:", err);
                return [];
            }
        },

        closeHandler() {
            this.progressDialog = false;
            this.isErr = false;
            this.isEdit= false;
            this.resetSelections();
        },


        resetSelections() {
            this.formData = {
                id: this.parentObject.kpi.id,
                reviewdate: null,
                achievement: null,
                progress: null,
                reviewerid: this.$store.getters.staffId,
                comment: null,
                attach: null,
                attachname: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            };

            if (this.$refs.attach) {
                this.$refs.attach.reset();
            }
        },

        async loadStaff(){
            const vm = this;

            try {
                const res = await vm.$store.dispatch("get", {
                    url: `/staff/alls`
                });

                const staffFull = res.data.rec || [];

                vm.staffList = staffFull.map(staff => ({
                    text: staff.psndetails,
                    psnname: staff.psnname,
                    staffcode: staff.staffcode,
                    staffcompany: staff.compnyname,
                    value: staff.id,
                }));
                console.log("STAFFLIST", vm.staffList);

            } catch (err) {
                console.error("Error in loadStaff:", err);
            }
        },
    },

    async mounted() {
        try {
            await this.loadStaff();
            this.loadProgressReviewList();
        } catch (err) {
            console.error("Error in mounted:", err);
        }
    },
   
};

</script>

<style>
.v-expansion-panel-header .v-icon.mdi-chevron-down.theme--light {
    color: #1a3a5c !important;
}
</style>

<style scoped>
.kpi-btn-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px 0 8px 0;
}

.kpi-page-title {
    font-size: 1.1rem;
    font-weight: 600;
    letter-spacing: normal;
    color: #1a3a5c;
    margin-bottom: 12px;
}

.fbtn {
    min-width: 90px !important;
    height: 36px !important;
    border-radius: 8px !important;
    font-size: 0.82rem !important;
    font-weight: 600 !important;
    text-transform: none !important;
    letter-spacing: 0.02em !important;
    box-shadow: none !important;
}

.fbtn-cancel {
    background: #F1F5F9 !important;
    color: #64748B !important;
}
.fbtn-cancel:hover {
    background: #E2E8F0 !important;
    color: #334155 !important;
}

.fbtn-secondary {
    background: #EEF2FF !important;
    color: #4F6BFF !important;
}
.fbtn-secondary:hover {
    background: #4F6BFF !important;
    color: #fff !important;
}

.dialog-header {
    font-size: 0.95rem !important;
    font-weight: 700 !important;
    color: #1a3a5c !important;
    letter-spacing: normal !important;
    padding: 14px 20px 10px 20px !important;
    border-bottom: 1px solid #E8EDF5;
}
</style>